export const reloadApp = () => {
  // eslint-disable-next-line functional/immutable-data
  window.location.href = window.location.origin;
};
